import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'
import { getToken, isSuper } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  { path: '/login', component: () => import('@/views/login/index.vue') },
  {
    path: '/',
    component: Layout,
    redirect: '/stats',
    children: [
      { path: 'stats', name: 'stats', component: () => import('@/views/stats/index.vue'), meta: { title: '数据看板' } },
      { path: 'menu', name: 'menu', component: () => import('@/views/menu/index.vue'), meta: { title: '菜单管理', super: true } },
      { path: 'employee', name: 'employee', component: () => import('@/views/employee/index.vue'), meta: { title: '顾客管理', super: true } },
      { path: 'export', name: 'export', component: () => import('@/views/export/index.vue'), meta: { title: '报表导出' } },
      { path: 'history', name: 'history', component: () => import('@/views/history/index.vue'), meta: { title: '历史查询' } },
      { path: 'setting', name: 'setting', component: () => import('@/views/setting/index.vue'), meta: { title: '订餐设置', super: true } }
    ]
  }
]

const router = new VueRouter({ routes })

router.beforeEach((to, from, next) => {
  if (to.path !== '/login' && !getToken()) {
    next('/login')
  } else if (to.meta && to.meta.super && !isSuper()) {
    next('/stats')
  } else {
    next()
  }
})

export default router
